import { Button, IButtonProps } from '@rocketmakers/armstrong';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { SeroProps } from '../props/SeroProps';

import './back-button.scss';

export type BackButtonProps = IButtonProps & SeroProps;

export const BackButton: React.FunctionComponent<BackButtonProps> = props => {
  const history = useHistory();

  return (
    <Button data-qa="back-button" className="back-button btn-icon" onClick={() => history.go(-1)} {...props}>
      <img src={require('../../../assets/images/installer/back.svg')} alt="Back" width={40} />
    </Button>
  );
};
